module.exports = __webpack_public_path__ + "static/media/logoTitle.58623810.svg";